<template>
    <activation-brief-networks-provider
        v-slot="{ brief, contact, networkId, instagramGraphRequired }"
        style="height: 100%"
    >
        <activation-brief-connect-network-view
            :brief="brief"
            :contact="contact"
            :network-id="networkId"
            :instagram-graph-required="instagramGraphRequired"
        />
    </activation-brief-networks-provider>
</template>

<script>
    import ActivationBriefNetworksProvider from '../../../../providers/activation-brief-steps/ActivationBriefNetworksProvider.vue';
    import ActivationBriefConnectNetworkView from './ActivationBriefConnectNetworkView.vue';
    export default {
        name: 'ActivationBriefConnectNetworkRouterView',
        components: {
            ActivationBriefConnectNetworkView,
            ActivationBriefNetworksProvider
        }
    };
</script>
